import LicenseProto from "./license-proto";
import {License} from "../const/license";

export default class LicensePro extends LicenseProto {

    constructor(license:License, maxUsers:number, licenseUsers:number) {
        super(license);

        this.maxUsers = maxUsers;

        this.isPro = true;

        this.billingAndFinance = true;

        this.maxStorage = 'Unlimited';

        this.name = 'Professional';

        this.isPaid = true;

        this.licenseUsers = (licenseUsers)?licenseUsers:false;
    }


}